import React from "react";

function StatsBoxes({ counts, statConfigs }) {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4 animate-in slide-in-from-bottom duration-700 delay-200'>
      {statConfigs.map((stat) => (
        <div
          key={stat.key}
          className='bg-white rounded-lg shadow-lg p-4 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group'
        >
          <div className='flex items-center'>
            <div className='flex-shrink-0'>
              <div className='flex justify-between items-center gap-2'>
                <div
                  className="flex items-center justify-center w-12 h-12 text-2xl font-bold rounded-lg group-hover:scale-110 transition-transform duration-200"
                  style={{
                    backgroundColor: stat.bgColor,
                    color: stat.textColor,
                  }}
                >
                  {counts[stat.key].toLocaleString()}
                </div>
                <div>
                  <p className='text-sm font-medium text-gray-600'>
                    {stat.title}
                  </p>
                  <p className='text-xs text-gray-500'>{stat.subtitle}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default StatsBoxes;